import { InputTextPassThroughOptions } from 'primereact/inputtext';

export const PTInputText: InputTextPassThroughOptions = {
  root: {
    className: 'ax-input',
  },
};
